import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import DotsMenu, { type DotsMenuProps } from "./component";
import { INVISIBLE_PROPS } from "./lib";
import { dotsMenuItemsSelector, onePageTypeSelector } from "./selectors";

const mapStateToProps = (state: AppState): DotsMenuProps & WithIsVisibleHOCProps => {
  const onePageType = onePageTypeSelector(state);
  if (onePageType !== "wsc-onepage-dots") return INVISIBLE_PROPS;

  return {
    isVisible: true,
    items: dotsMenuItemsSelector(state)
  };
};

export default connectCustom(mapStateToProps)(DotsMenu);
